import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { buildSeoAlternates } from "@/src/components/helpers/seo";

const Seo = ({ title, description, keywords, noindex = false }) => {
  const { asPath, locale } = useRouter();
  const { canonical, languageAlternates } = buildSeoAlternates(asPath, locale);

  return (
    <NextSeo
      title={title}
      description={description}
      defaultTitle={title}
      noindex={noindex}
      nofollow={noindex}
      canonical={canonical}
      languageAlternates={languageAlternates}
      additionalMetaTags={[
        {
          name: "keywords",
          content: keywords,
        },
      ]}
    />
  );
};

export default Seo;
